/**
 * Validates a post-login return path (backlog AUTH — login-redirect gap,
 * 2026-09-14): requireAccess() carries the page someone was actually
 * trying to reach through `/login`'s `state.from`, and through OAuth's
 * full external redirect via a `?returnTo=` query param instead (React
 * Router state doesn't survive that round trip). Both call this before
 * ever navigating to a caller-influenced value — `//evil.com` is parsed
 * by browsers as protocol-relative (same scheme, different host), which
 * a bare `startsWith("/")` check alone would let through as if it were a
 * safe same-app path. Every real value here is one this app generated
 * itself (never taken from a URL a user could hand-craft targeting
 * another origin), but the check costs nothing and removes the need to
 * trust that invariant forever holding.
 */
export function safeReturnPath(candidate: unknown): string | null {
  if (typeof candidate !== "string") return null;
  if (!candidate.startsWith("/") || candidate.startsWith("//")) return null;
  return candidate;
}
